import { render, staticRenderFns } from "./masterdata-ui.vue?vue&type=template&id=e7e66754&lang=html&"
import script from "./masterdata-ui.vue?vue&type=script&lang=js&"
export * from "./masterdata-ui.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports